<template>
  <div id="profileView">
    <mu-content-block v-if="isLoading" style="text-align: center">
      <mu-circular-progress :size="32"></mu-circular-progress>
      <br/> <span v-text="$t('message.loadingText')"></span>
    </mu-content-block>
    <div v-if="!$route.meta.isChild && !isLoading">
      <profile-header class="insetGraph" v-if="profile.user_id" :profile="profile"></profile-header>
      <div id="scroll-detector"></div>
      <mu-paper id="profileTabs" class="insetTabBar innerProfile" v-bind:class="{isDocked: avatarDocked}">
        <mu-row gutter class="padRow">
          <mu-col desktop="25" tablet="30" style="position:relative" align="center">
            <mu-avatar v-show="avatarDocked === false" class="relativeAvatar desktop" :size="190"
                       :src="profile.profile_image"></mu-avatar>
            <mu-flexbox v-show="avatarDocked === true" style="height: 52px;" align="center" justify="center">
              <mu-flexbox-item shrink="9" grow="1" align="center">
                <mu-avatar style="position: relative; top: 4px;" class="desktop" :size="34"
                           :src="profile.profile_image"></mu-avatar>
              </mu-flexbox-item>
              <mu-flexbox-item grow="3">
                <span>{{profile.display_name}}</span>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-col>
          <mu-col desktop="75" tablet="70">
            <ul>
              <li v-for="route in routes" v-bind:class="{active: route.name === $route.name}" v-if="hideTabItems(route.name)">
                <a @click="goTo(route.name)" v-text="route.label"></a>
              </li>
            </ul>
          </mu-col>
        </mu-row>
      </mu-paper>
      <div style="clear: both;"></div>
      <div class="innerProfile" v-bind:class="{isDocked: avatarDocked}">
        <router-view class="routerView mobile" v-if="!$route.meta.isChild && profile" :profile="profile"></router-view>
        <mu-row gutter class="padRow">
          <mu-col class="profileAvatar" width="100" desktop="25" tablet="30">
            <profile-avatar v-if="!isLoading" :profile="profile"></profile-avatar>
          </mu-col>
          <mu-col  class="routerView desktop" width="100" desktop="75" tablet="70" v-if="profile">
            <router-view v-if="!$route.meta.isChild" :profile="profile"></router-view>
          </mu-col>
        </mu-row>
      </div>
    </div>
  </div>
</template>
<script>
  import "./Profile.less";


  import EventBus from '../../helpers/EventBus/index'
  import ProfileApi from './../../api/Profile'
  import UserManager from '../../helpers/UserManager'
  import TitleManager from '../../helpers/TitleManager'
  import ScrollerMixin from '../../mixins/ScrollerMixin'
  import HcpMixin from '../../mixins/HCPMixin'
  import ScrollManager from '../../helpers/ScrollManager'



  import UserAvatar from "../../components/UserAvatar/UserAvatar";
  import ProfileHeader from "../../components/Profile/ProfileHeader/ProfileHeader";
  import BgLineGraph from "../../components/Tracking/Graphs/BloodGlucose/LineGraph";
  import WeightLineGraph from "../../components/Tracking/Graphs/Weight/LineGraph";
  import ProfileGallery from "../../components/Profile/Gallery/Gallery";
  import UserProfileQuestions from "../../components/Profile/UserQuestions/UserQuestions.vue";

  import 'gsap'
  import moment from "moment";


  export default {
    mixins: [ScrollerMixin, HcpMixin],
    components: {
      UserProfileQuestions,
      ProfileGallery,
      WeightLineGraph,
      BgLineGraph,
      ProfileHeader,
      UserAvatar
    },
    name: 'profile',
    watch: {
      '$route': function () {
        let self = this;
        self.initMounted();
        $('#profile').scrollTop(0);
      }
    },
    data() {
      return {
        isLoading: true,
        profile: {},
        privacy: {},
        gallery: [],
        authUser: {},
        routes: [
          {
            name: "ProfileProgress",
            label: this.$t('message.labelProgress'),
            route: "progress"
          },
          {
            name: "ProfileDiscussion",
            label: this.$t('message.labelPostsAndReplies'),
            route: "discussion"
          },
          {
            name: "ProfileGallery",
            label: this.$t('message.labelGallery'),
            route: "gallery"
          },
          {
            name: "ProfileFoodDiary",
            label: this.$t('message.labelFood'),
            route: "food-diary"
          }
        ],
        avatarDocked: false,
        window: undefined,
        contentElement: undefined,
        profileTabs: undefined,
        profileHeader: undefined
      }
    },
    mounted() {
      let self = this;
      self.initMounted();
      self.window = $(window);
      self.contentElement = $('.main-content');
      self.profileHeader = $('#profileHeader');

      self.scroller.addEventListener('scroll', self.onScroll);
      if(!self.isHcpView) {
        self.$router.replace({
          name: 'ProfileProgress',
        })
      }
    },
    methods: {
      hideTabItems(name) {
        let self = this;
        if( self.isHcpView ) {
          if(name === 'ProfileFoodDiary' || name === 'ProfileProgress') {
            return false;
          }
        }
        return true;
      },
      onScroll() {
        let self = this;
        let windowWidth = self.window.outerWidth(true);
        if (windowWidth >= 1024) {
          if (ScrollManager.isElementInContentView(document.getElementById('scroll-detector'))) {
            self.avatarDocked = false;
            self.unDockAvatar();
          }
          else {
            self.avatarDocked = true;
            $('#profileTabs').attr('style', 'width: ' + self.contentElement.prop("clientWidth") + 'px');
          }
        }
        else {
          self.unDockAvatar();
        }
      },
      unDockAvatar() {
        let self = this;
        self.avatarDocked = false;

        $('#profileTabs').removeAttr('style');
        self.$forceUpdate();
      },
      goTo(name) {
        let self = this;
        self.$router.replace({
          name: name,
        });
      },
      initMounted() {
        let self = this;
        self.loadProfile();
      },
      setTitle(title) {
        TitleManager.setTitle(title);
      },
      loadProfile() {
        let self = this;
        let url = self.$route.params.profileUrl;
        self.$gtag.pageview('/profile/' + url);
        self.setTitle(self.$t('message.loadingText'));
        self.authUser = self.$store.state.user.scope;
        ProfileApi.getProfile(url).then(function (response) {
          if (_.has(response.data.information, 'basic')) {
            let user_id = response.data.information.basic.user_id;
            self.$store.commit('setActiveProfile', user_id);
            self.$store.commit('setActiveProfileObject', response.data);
            self.profile = response.data.information.basic;
            self.gallery = response.data.gallery;
            self.privacy = response.data.privacy;
            self.isLoading = false;
            self.setTitle(`${self.profile.display_name}`);
            $('#profile').scrollTop(0);
            if (ScrollManager.isElementInContentView(document.getElementById('scroll-detector'))) {
              self.avatarDocked = false;
              self.unDockAvatar();
            }
          }
        });
      },
      replaceDashes(url) {
        url = url.split('-').join('.');
        return url;
      }
    },
    beforeDestroy() {
      let self = this;
      self.scroller.removeEventListener('scroll', self.onScroll);
    }
  }
</script>
<style>
  .relativeAvatar {
    width: 200px;
    height: 200px;
    margin-top: -152px;
    padding: 5px;
  }

  @media (min-width: 982px) {
    #profile .padRow {
      width: 1024px;
      margin: 0 auto
    }
  }

  @media (min-width: 2000px) {
    #profile .padRow {
      width: 1200px !important;
      margin: 0 auto
    }
  }

  .innerProfile.isDocked {
    margin-top: 78px;
  }

  div#profileTabs.isDocked {
    position: fixed;
    top: 64px;
    z-index: 2;
    width: 100%;
    margin: 0 !important;
  }

  @media (max-width: 992px) {
    .relativeAvatar.desktop {
      display: none;
    }
    .mu-card-text.profile-header-content {
      position: relative;
      top: 48px;
    }
  }




</style>



// WEBPACK FOOTER //
// Profile.vue?0009b105